import DataObjectList from '../../../common/model/DataObjectList';

import ContractAlert from './ContractAlert';

export default class ContractAlertList extends DataObjectList {
  getElementClassType() {
    return ContractAlert;
  }
}